import React from "react";

const Footer = () => {
  return (
    <footer className="footer-center p-3 shadow-lg bg-slate-200 text-black">
      <div className="text-center">
        <p>
          Copyright © 2023 -&nbsp;
          <a
            className="font-semibold"
            href="mailto:jaimin.chokhawala@gmail.com"
          >
            Jaimin Chokhawala
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
